import React from 'react';
import { observer } from 'mobx-react';
import ModeExcel from '../../stores/card/ModeExcel';

export interface ExcelTableColgroupProps {
    excel?: ModeExcel;
}

@observer
export default class ExcelTableColgroup extends React.Component<ExcelTableColgroupProps, any> {
    render() {
        const { excel } = this.props;
        return (
            <colgroup>
                {
                    excel&&excel.cols.slice().map(({ size,hide },index) => {
                        return (
                            <col   width= {size } style={{display:hide && hide ==="y" ? "none":""}} />
                        )
                    })
                }
            </colgroup>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/Colgroup.tsx